import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Slider} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Slider, {
        'range': true,
        'ev-change': (v) => console.log(v),
        'ev-$model:value': function($v) {
            $this.set('values', $v);
        },
        'value': $this.get('values')
    });
};